import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Lmw1c252MzAgewogIG9iamVjdC1maXQ6IGNvdmVyOwp9';
import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Lmw1c252MzEgewogIGJvcmRlci1yYWRpdXM6IDdweDsKfQ';
import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Lmw1c252MzIgewogIGJvcmRlci1yYWRpdXM6IDk5cHg7Cn0';
import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Lmw1c252MzMgewogIG1hcmdpbi10b3A6IC0zcHg7Cn0';
export var avatar = {organization:'l5snv31 l5snv30',person:'l5snv32 l5snv30'};
export var tagline = 'l5snv33';